import angular from 'angular';

// routes
import bookingListRoute from './reservations/dayview/route';
import giftFormRoute from './gifts/route';
import bundleFormRoute from './bundles/route';

// components
import creditCardComponent from './card';
import calendarComponent from './calendar';
import bundleComponent from './bundles';

const MODULE_NAME = 'RessieApp';

bookingListRoute(MODULE_NAME);
giftFormRoute(MODULE_NAME);
bundleFormRoute(MODULE_NAME);

calendarComponent(MODULE_NAME);
bundleComponent(MODULE_NAME);
creditCardComponent(MODULE_NAME);

export default MODULE_NAME;



// WEBPACK FOOTER //
// ./client/assets/scripts/modules/core.js